import { Tabs } from 'FormsUI/constants/Submissions';
export const COMPARISON_LIMIT = 10;
export const OVERVIEW_SECTION = {
  section: 'overview',
  rows: [{
    key: 'views',
    fromStatistics: true,
    linkPath: Tabs.PERFORMANCE
  }, {
    key: 'submissions',
    fromStatistics: true,
    linkPath: Tabs.SUBMISSIONS
  }, {
    key: 'submissionRate',
    fromStatistics: true,
    asPercentage: true
  }]
};
export const FIELDS_SECTION = (
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'isUngatedForCompanies' implicitly has a... Remove this comment to see the full error message
isUngatedForCompanies) => ({
  section: 'fields',
  rows: [{
    key: 'totalNoOfFields',
    fromStatistics: true,
    isFormField: true
  }, {
    key: 'contactProperties',
    fromStatistics: true,
    isFormField: true
  }, ...(isUngatedForCompanies ? [{
    key: 'companyProperties',
    fromStatistics: true,
    isFormField: true
  }] : []), {
    key: 'ticketProperties',
    fromStatistics: true,
    isFormField: true
  }, {
    key: 'customObjectProperties',
    fromStatistics: true,
    isFormField: true
  }]
});
export const SETTINGS_SECTION = isUngatedForPagination => ({
  section: 'settings',
  rows: [{
    key: 'captchaEnabled',
    fromStatistics: true,
    asBoolean: true
  }, {
    key: 'inlineMessage',
    fromStatistics: true,
    isResizable: true,
    fallback: '-'
  }, {
    key: 'redirect',
    fromStatistics: true,
    isResizable: true,
    fallback: '-'
  }, {
    key: 'progressiveFieldLogic',
    fromStatistics: true,
    isFormField: true
  }, {
    key: 'dependentFieldLogic',
    fromStatistics: true,
    isFormField: true
  }, ...(isUngatedForPagination ? [{
    key: 'multiStepForm',
    asYesNo: true
  }] : [])]
});
export const DESIGN_SECTION = {
  section: 'design',
  rows: [{
    key: 'themeName',
    fromStatistics: true,
    fallback: '-'
  }, {
    key: 'fontFamily',
    fromStatistics: true,
    usesStyle: true,
    fallback: '-'
  }, {
    key: 'labelTextColor',
    fromStatistics: true,
    usesStyle: true,
    asColor: true,
    fallback: '-'
  }, {
    key: 'helpTextColor',
    fromStatistics: true,
    usesStyle: true,
    asColor: true,
    fallback: '-'
  }, {
    key: 'legalConsentTextColor',
    fromStatistics: true,
    usesStyle: true,
    asColor: true,
    fallback: '-'
  }, {
    key: 'submitColor',
    fromStatistics: true,
    usesStyle: true,
    asColor: true,
    fallback: '-'
  }, {
    key: 'submitAlignment',
    fromStatistics: true,
    usesStyle: true,
    fallback: '-'
  }]
};
export const VALUE_TYPES = {
  DATE: 'DATE',
  PERCENTAGE: 'PERCENTAGE',
  BOOLEAN: 'BOOLEAN',
  YES_NO: 'YES_NO',
  COLOR: 'COLOR'
};
export const PERFORMANCE_KEYS = {
  VIEWS: 'views',
  SUBMISSION_RATE: 'submissionRate'
};